module.exports = __webpack_public_path__ + "media/how_does_sharing_work/tada-d38c3af4.svg";